module.exports = __webpack_public_path__ + "static/media/showcase-full.01cefa13.png";